import React from 'react';
import ReactDOM from 'react-dom/client';
import './design-tokens/design-tokens.css';  // Import design tokens
import AppRouter from './AppRouter';
import EnvironmentBuildBadge from './components/common/EnvironmentBuildBadge';

const rootElement = document.getElementById('root');
const modalRoot = document.createElement('div');
modalRoot.id = 'modal-root';    //keep the modals in a separate branch from the rest of the code so it will always appear on top
document.body.appendChild(modalRoot);
const root = ReactDOM.createRoot(rootElement);

root.render(
    <>
        <AppRouter />
        <EnvironmentBuildBadge />
    </>
);
